import React, {PureComponent} from 'react';
import ReactDOM from 'react-dom';
import root from 'window-or-global';

import LoadingBar from '../LoadingBar';
import {elements} from '../../../constants';

import styles from './LoadingBarPortal.pcss';

class LoadingBarPortal extends PureComponent {
    state = {
        el: null
    };

    componentDidMount() {
        const el = root.document.getElementById(elements.LOADING_BAR_PORTAL_ID);
        this.setState({el}); // eslint-disable-line react/no-did-mount-set-state
    }

    render() {
        return (
            this.state.el &&
            ReactDOM.createPortal(<LoadingBar className={styles.loadingBar} />, this.state.el)
        );
    }
}

export default LoadingBarPortal;
